import enTranslations from '../locales/en.json';
import koTranslations from '../locales/ko.json';

const LOCALE_STORAGE_KEY = 'fancian-admin-locale';
let storedLocale;
try { storedLocale = typeof window !== 'undefined' && localStorage.getItem(LOCALE_STORAGE_KEY); } catch (_) { /* Use the default. */ }
const initialLocale = storedLocale === 'en' ? 'en' : 'ko';
if (typeof document !== 'undefined') document.documentElement.lang = initialLocale;

let currentLocale = initialLocale;
let translations = initialLocale === 'ko' ? koTranslations : enTranslations;

export const t = (key, params = {}) => {
  const keys = key.split('.');
  let value = translations;
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return key;
    }
  }
  if (typeof value !== 'string') return key;
  if (params && Object.keys(params).length > 0) {
    return value.replace(/\{\{(\w+)\}\}/g, (match, paramKey) =>
      params[paramKey] !== undefined ? params[paramKey] : match
    );
  }
  return value;
};

export const setLocale = (locale) => {
  currentLocale = locale;
  translations = locale === 'ko' ? koTranslations : enTranslations;
  if (typeof window !== 'undefined') {
    document.documentElement.lang = locale;
    try { localStorage.setItem(LOCALE_STORAGE_KEY, locale); } catch (_) { /* Keep the choice in memory. */ }
  }
};

export const getLocale = () => currentLocale;

const i18n = { t, setLocale, getLocale };
export default i18n;
